export interface Faq {
  question: string;
  answer: string;
  group: "使用指引" | "内容说明";
}

export const faqs: Faq[] = [
  {
    question: "51爆料网主要有哪些栏目？",
    answer:
      "网站目前设有八个常设栏目，分为三类：首页栏目包括「实时热点」与「热点排行榜」；专题频道包括「深度调查」「行业观察」和「事件专题」；内容板块包括「消费爆料」「辟谣科普」与「生活警示」。你可以在栏目导航页完整查看所有入口。",
    group: "使用指引",
  },
  {
    question: "栏目导航页应该怎么用？",
    answer:
      "栏目导航页是本站的站点导览入口，把所有栏目、专题频道和内容板块集中在一页。如果你想直接找某一类内容，先到导航页定位对应板块，再进入频道页浏览文章列表，会比逐页翻找更快。",
    group: "使用指引",
  },
  {
    question: "深度调查和实时热点有什么区别？",
    answer:
      "实时热点侧重时效，把当天正在被讨论的话题用简明脉络整理出来，帮助快速了解信息重点；深度调查则投入更长时间，通过走访当事人、查阅公开资料和比对多方说法，还原事件的完整链路。两者关注同一领域，但节奏和深度不同。",
    group: "内容说明",
  },
  {
    question: "内容多久更新一次？",
    answer:
      "实时热点与热点排行榜通常每个工作日更新；辟谣科普和消费爆料按选题排期更新；深度调查与事件专题不追求高频，会根据事实进展在合适的时间发布或补充更新。",
    group: "内容说明",
  },
  {
    question: "看到的内容与事实有出入怎么办？",
    answer:
      "欢迎通过邮箱 hello@51baoliao.com 指出具体问题，并尽量附上相关信息来源。我们会在核实后对内容进行补充、更正或在文末添加说明，而不是直接删除。",
    group: "内容说明",
  },
  {
    question: "可以投稿或提供线索吗？",
    answer:
      "可以。你可以把线索整理成简短的文字，说明时间、地点与关键事实，并尽量说明可核实的方式，发送至联系邮箱。我们不承诺每条线索都会成稿，但会认真阅读并评估。",
    group: "使用指引",
  },
  {
    question: "为什么有的说法会被标为「被夸大」？",
    answer:
      "在辟谣科普栏目中，我们会把结论分为「有依据」「被夸大」和「完全不实」三种。被夸大通常指说法本身有一点事实基础，但在传播过程中被放大或去掉了适用条件，因此需要单独说明，而不是简单判定为真或假。",
    group: "内容说明",
  },
  {
    question: "站内内容可以转载吗？",
    answer:
      "出于传播目的，欢迎非商业性质的转载，但请保留原文标题与来源说明，且不得对内容进行断章取义的改动。如需商业使用，请先通过邮箱与我们沟通。",
    group: "使用指引",
  },
];